import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatCurrency = (amount, currency = 'SAR') => {
  return new Intl.NumberFormat('en-SA', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
  }).format(amount);
};

export const formatDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getStatusConfig = (status) => {
  const configs = {
    DRAFT: {
      label: 'Draft',
      color: 'bg-gray-100 text-gray-800 border-gray-200',
      dotColor: 'bg-gray-500',
    },
    SUBMITTED: {
      label: 'Submitted',
      color: 'bg-blue-50 text-blue-700 border-blue-200',
      dotColor: 'bg-blue-500',
    },
    HOLD: {
      label: 'On Hold',
      color: 'bg-yellow-50 text-yellow-700 border-yellow-300',
      dotColor: 'bg-yellow-500',
    },
    PENDING_ADDITIONAL_APPROVAL: {
      label: 'Pending 2nd Manager',
      color: 'bg-purple-50 text-purple-700 border-purple-200',
      dotColor: 'bg-purple-500',
    },
    ADDITIONAL_MANAGER_APPROVED: {
      label: '2nd Manager Approved',
      color: 'bg-indigo-50 text-indigo-700 border-indigo-200',
      dotColor: 'bg-indigo-500',
    },
    ADDITIONAL_MANAGER_REJECTED: {
      label: '2nd Manager Rejected',
      color: 'bg-red-50 text-red-700 border-red-200',
      dotColor: 'bg-red-500',
    },
    MANAGER_APPROVED: {
      label: 'Manager Approved',
      color: 'bg-indigo-50 text-indigo-700 border-indigo-200',
      dotColor: 'bg-indigo-500',
    },
    MANAGER_REJECTED: {
      label: 'Manager Rejected',
      color: 'bg-red-50 text-red-700 border-red-200',
      dotColor: 'bg-red-500',
    },
    INTERNAL_AUDIT_APPROVED: {
      label: 'Audit Approved',
      color: 'bg-cyan-50 text-cyan-700 border-cyan-200',
      dotColor: 'bg-cyan-500',
    },
    INTERNAL_AUDIT_REJECTED: {
      label: 'Audit Rejected',
      color: 'bg-amber-50 text-amber-700 border-amber-200',
      dotColor: 'bg-amber-500',
    },
    FINANCE_HEAD_APPROVED: {
      label: 'Finance Head Approved',
      color: 'bg-violet-50 text-violet-700 border-violet-200',
      dotColor: 'bg-violet-500',
    },
    FINANCE_HEAD_REJECTED: {
      label: 'Finance Head Rejected',
      color: 'bg-rose-50 text-rose-700 border-rose-200',
      dotColor: 'bg-rose-500',
    },
    ACCOUNTS_APPROVED: {
      label: 'Accounts Approved',
      color: 'bg-emerald-50 text-emerald-700 border-emerald-200',
      dotColor: 'bg-emerald-500',
    },
    ACCOUNTS_REJECTED: {
      label: 'Accounts Rejected',
      color: 'bg-orange-50 text-orange-700 border-orange-200',
      dotColor: 'bg-orange-500',
    },
    PAID: {
      label: 'Paid',
      color: 'bg-green-50 text-green-800 border-green-300',
      dotColor: 'bg-green-600',
    },
  };
  return configs[status] || configs.DRAFT;
};

export const getRoleConfig = (role) => {
  const configs = {
    admin: { label: 'Admin', color: 'bg-purple-100 text-purple-800' },
    manager: { label: 'Manager', color: 'bg-blue-100 text-blue-800' },
    internal_audit: { label: 'Internal Audit', color: 'bg-cyan-100 text-cyan-800' },
    finance_head: { label: 'Finance Head', color: 'bg-violet-100 text-violet-800' },
    accounts: { label: 'Accounts', color: 'bg-green-100 text-green-800' },
    employee: { label: 'Employee', color: 'bg-gray-100 text-gray-800' },
  };
  return configs[role] || configs.employee;
};

export const getPaymentMethodLabel = (method) => {
  const labels = {
    CASH: 'Cash',
    CHECK: 'Cheque',
    TRANSFER: 'Bank Transfer',
    SADAD: 'SADAD',
  };
  return labels[method] || method;
};

export const getPaymentTypeLabel = (type) => {
  const labels = {
    ADVANCE: 'Advance Payment',
    ON_ACCOUNT: 'On Account',
    BALANCE: 'Balance Payment',
  };
  return labels[type] || type;
};
